import { QueryHookOptions, useQuery } from "@apollo/react-hooks";

import { CoveredRegion } from "@hubcapp/types";
import { WatchQueryFetchPolicy } from "apollo-client";

import coverageQuery from "../graph-ql/coverage.graphql";

const useQueryCoverage = (
  id: string,
  onCompleted?: QueryHookOptions["onCompleted"],
  cachePolicy: WatchQueryFetchPolicy = "cache-first",
) =>
  useQuery<{ coverage: CoveredRegion }>(coverageQuery, {
    variables: {
      id,
    },
    skip: !id,
    fetchPolicy: cachePolicy,
    onCompleted,
  });

export default useQueryCoverage;
